/**
 * Performance-tracing-события (load_*).
 *
 * MOB-164: события отключены — функции no-op. Тела с реальными вызовами
 * Analytics.send и FirebasePerformance.record сохранены закомментированными,
 * чтобы при необходимости вернуть отправку достаточно было раскомментировать
 * соответствующий блок и при необходимости импорты ниже.
 *
 * Вызовы остаются в компонентах для прозрачности: где и когда
 * закончилась загрузка экрана. В аналитику и Firebase Performance
 * ничего не уходит.
 */

// import Analytics from '@web/services/Analytics/Analytics'
// import FirebasePerformance from '@web/services/firebasePerformance'

export interface LoadTracePayload {
  label?: string
  startLoading?: number
  duration?: number
  attributes?: Record<string, string>
}

export function traceLoadApp (_payload: LoadTracePayload = {}): void {
  // MOB-164: отключено. Раньше отправлялось:
  //
  // FirebasePerformance.record({
  //   traceName: 'load_app',
  //   startTime: _payload.startLoading,
  //   duration: _payload.duration
  // })
}

export function traceLoadHome (_payload: LoadTracePayload = {}): void {
  // MOB-164: отключено. Раньше отправлялось:
  //
  // Analytics.send({
  //   category: 'ux.performance',
  //   action: 'load_home',
  //   label: _payload.label
  // })
  // FirebasePerformance.record({
  //   traceName: 'load_home',
  //   startTime: _payload.startLoading
  // })
}

export function traceLoadDay (_payload: LoadTracePayload = {}): void {
  // MOB-164: отключено. Раньше отправлялось:
  //
  // Analytics.send({
  //   category: 'ux.performance',
  //   action: 'load_day',
  //   label: _payload.label
  // })
  // FirebasePerformance.record({
  //   traceName: 'load_day',
  //   startTime: _payload.startLoading,
  //   options: { attributes: _payload.attributes }
  // })
}

export function traceLoadCalendar (_payload: LoadTracePayload = {}): void {
  // MOB-164: отключено. Раньше отправлялось:
  //
  // Analytics.send({
  //   category: 'ux.performance',
  //   action: 'load_calendar',
  //   label: _payload.label
  // })
  // FirebasePerformance.record({
  //   traceName: 'load_calendar',
  //   startTime: _payload.startLoading,
  //   options: { attributes: _payload.attributes }
  // })
}

export function traceLoadCourses (_payload: LoadTracePayload = {}): void {
  // MOB-164: отключено. Раньше отправлялось:
  //
  // Analytics.send({
  //   category: 'ux.performance',
  //   action: 'load_courses',
  //   label: _payload.label
  // })
  // FirebasePerformance.record({
  //   traceName: 'load_courses',
  //   startTime: _payload.startLoading
  // })
}

export function traceLoadHomeworks (_payload: LoadTracePayload = {}): void {
  // MOB-164: отключено. Раньше отправлялось:
  //
  // Analytics.send({
  //   category: 'ux.performance',
  //   action: 'load_homeworks',
  //   label: _payload.label
  // })
  // FirebasePerformance.record({
  //   traceName: 'load_homeworks',
  //   startTime: _payload.startLoading
  // })
}

export function traceLoadChats (_payload: LoadTracePayload = {}): void {
  // MOB-164: отключено. Раньше отправлялось:
  //
  // Analytics.send({
  //   category: 'ux.performance',
  //   action: 'load_chats',
  //   label: _payload.label
  // })
  // FirebasePerformance.record({
  //   traceName: 'load_chats',
  //   startTime: _payload.startLoading,
  //   options: { attributes: _payload.attributes }
  // })
}

export function traceLoadFreezePage (_payload: LoadTracePayload = {}): void {
  // MOB-164: отключено. Раньше отправлялось:
  //
  // Analytics.send({
  //   category: 'ux.performance',
  //   action: 'load_freezePage',
  //   label: _payload.label
  // })
  // FirebasePerformance.record({
  //   traceName: 'load_freezePage',
  //   startTime: _payload.startLoading,
  //   options: { attributes: _payload.attributes }
  // })
}

export function traceLoadHomework (_payload: LoadTracePayload = {}): void {
  // MOB-164: отключено. Раньше отправлялось:
  //
  // FirebasePerformance.record({
  //   traceName: 'load_homework',
  //   startTime: _payload.startLoading,
  //   options: { attributes: _payload.attributes }
  // })
}

export function traceLoadVideoconsultation (_payload: LoadTracePayload = {}): void {
  // MOB-164: отключено. Раньше отправлялось:
  //
  // FirebasePerformance.record({
  //   traceName: 'load_videoconsultation',
  //   startTime: _payload.startLoading,
  //   options: { attributes: _payload.attributes }
  // })
}

export function traceLoadVideoconsultations (_payload: LoadTracePayload = {}): void {
  // MOB-164: отключено. Раньше отправлялось:
  //
  // FirebasePerformance.record({
  //   traceName: 'load_videoconsultations',
  //   startTime: _payload.startLoading
  // })
}
